import ApiService from './../../services/ApiService';
import React, { useState } from 'react';
import './UploadComponent.css';
import './../../App.css';
import '../admin/AdminPage.css';

const UploadAnimeComponent = () => {
  const [file, setFile] = useState(null);
  const [animeId, setAnimeId] = useState('');
  const [seriesNum, setSeriesNum] = useState('');
  const [seasonNum, setSeasonNum] = useState('');
  const [key, setKey] = useState('');
  const [url, setUrl] = useState('');
  const [error, setError] = useState(null);
  const [priority, setPriority] = useState(1);
  const [successMessage, setSuccessMessage] = useState('');
  const [notify, setNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quality, setQuality] = useState('FULL_HD'); // New state for quality

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccessMessage('');
    setLoading(true);

    try {
      const response = await ApiService.uploadAnime(file, animeId, seriesNum, seasonNum, url, key, priority, notify, quality);
      if (response.type === 'success') {
        setSuccessMessage(`Видео загружено: id ${response.data.id}, серия ${response.data.seriesNum}`);
      } else {
        setError(`Ошибка загрузки: ${JSON.stringify(response.data)}`);
      }
    } catch (error) {
      setError('Ошибка загрузки');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="ui-panel upload-form">
      <div className="upload-file-row">
        <label htmlFor="background-upload" className="ui-btn ui-btn--secondary upload-file-button">
          Выбрать файл
          <input id="background-upload" type="file" accept="*" onChange={handleFileChange} />
        </label>
        <span className="upload-file-name">{file ? file.name : 'Файл не выбран'}</span>
      </div>
      <div className="upload-fields">
        <label className="admin-field" htmlFor="animeId">
          <span>Anime ID</span>
          <input
            type="text"
            id="animeId"
            value={animeId}
            onChange={(e) => setAnimeId(e.target.value)}
            placeholder="Anime ID"
          />
        </label>
        <label className="admin-field" htmlFor="seriesNum">
          <span>Номер серии</span>
          <input
            type="number"
            id="seriesNum"
            value={seriesNum}
            onChange={(e) => setSeriesNum(e.target.value)}
            placeholder="Номер серии"
          />
        </label>
        <label className="admin-field" htmlFor="seasonNum">
          <span>Номер сезона</span>
          <input
            type="number"
            id="seasonNum"
            value={seasonNum}
            onChange={(e) => setSeasonNum(e.target.value)}
            placeholder="Номер сезона"
          />
        </label>
        <label className="admin-field" htmlFor="url">
          <span>Сервер загрузки</span>
          <input
            type="text"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="Сервер загрузки"
          />
        </label>
        <label className="admin-field" htmlFor="priority">
          <span>Приоритет</span>
          <input
            type="number"
            id="priority"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
            placeholder="Приоритет > 0"
          />
        </label>
        <label className="admin-field" htmlFor="key">
          <span>Секретный токен</span>
          <input
            type="text"
            id="key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Секретный токен"
          />
        </label>
        <label className="admin-field" htmlFor="quality">
          <span>Качество видео</span>
          <select
            id="quality"
            value={quality}
            onChange={(e) => setQuality(e.target.value)}
          >
            <option value="FULL_HD">FULL HD</option>
            <option value="QHD">QHD</option>
            <option value="ULTRA_HD">ULTRA_HD</option>
          </select>
        </label>
      </div>

      <div className="upload-actions">
        <input
          type="checkbox"
          id="available"
          name="available"
          checked={notify}
          onChange={(e) => setNotify(e.target.checked)}
        />
        <label className='label-switch' htmlFor="available">Уведомить</label>
        <button type="submit" className="ui-btn upload-submit" disabled={loading}>
          {loading ? 'Загрузка…' : 'Загрузить'}
        </button>
      </div>
      {loading ? <div className="loader"></div> : null}
      {error && <div className="admin-notice error" role="alert">{error}</div>}
      {successMessage && <div className="admin-notice success" role="status">{successMessage}</div>}
    </form>
  );
};

export default UploadAnimeComponent;
